import { useCallback, useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer";
import { ClipLoader } from "react-spinners";
import Mentors from "./components/mentors/mentors";
import Offerings from "./components/offerings/doyenAccessOfferings";
import Services from "./components/services/doyenAccessServices";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import Hero from "./components/hero/doyenAccessHero";
import Header from "../../components/header/header";
import "./index.css";
import { baseUrl, GetToken, getUserCountry, PopulateContext } from "../../App";
import { useUsers } from "../../components/Contexts/UsersContext";

const Nigeria = "/images/nigeria.png";
const Estonia = "/images/estonia.png";
const Germany = "/images/germany.png";
const Finland = "/images/finland.png";
const Malaysia = "/images/malaysia.png";
const Portugal = "/images/portugal.png";
const Netherlands = "/images/netherlands.png";

const mentors = [
  {
    icon: "/images/doyen_access/olugbenga_access.svg",
    name: "Gbenga Oluyide",
    stack: "Software Engineer",
    experience: 10,
    sessions: 25,
    countries: [Nigeria, Estonia, Germany, Finland],
  },
  {
    icon: "/images/doyen_access/solagbade_access.svg",
    name: "Sola Enitilo",
    stack: "Software Engineer",
    experience: 10,
    sessions: 23,
    countries: [Nigeria, Estonia, Malaysia],
  },
  {
    icon: "/images/doyen_access/mr-otegbayo.svg",
    name: "Tayo Otegbayo",
    stack: "Software Engineer",
    experience: 10,
    sessions: 24,
    countries: [Nigeria, Portugal, Netherlands],
  },
  {
    icon: "/images/doyen_access/johnson_access.svg",
    name: "Adekunle Johnson",
    stack: "Software Engineer",
    experience: 9,
    sessions: 22,
    countries: [Nigeria],
  },
  {
    icon: "/images/doyen_access/kehinde_access.svg",
    name: "Kehinde Adebayo",
    stack: "Software Engineer",
    experience: 7,
    sessions: 23,
    countries: [Nigeria],
  },
  {
    icon: "/images/doyen_access/ahmed_access.svg",
    name: "Toyib Ahmed",
    stack: "Software Engineer",
    experience: 8,
    sessions: 21,
    countries: [Nigeria, Estonia],
  },
  {
    icon: "/images/doyen_access/olumide_access.svg",
    name: "Olumide Oyatola",
    stack: "Data Analyst",
    experience: 10,
    sessions: 25,
    countries: [Nigeria],
  },
  {
    icon: "/images/doyen_access/tolu_access.svg",
    name: "Tolu Johnson",
    stack: "Software Engineer",
    experience: 7,
    sessions: 21,
    countries: [Nigeria],
  },
  {
    icon: "/images/doyen_access/mr-ayoola.svg",
    name: "Ayoola Ayooluwa",
    stack: "Software Engineer",
    experience: 7,
    sessions: 20,
    countries: [Nigeria, Estonia],
  },
];

const DoyenAccess = () => {
  const [ready, setReady] = useState(false);
  const { User, setUserContext, setUsersContext } = useUsers();
  const navigate = useNavigate();
  const displayDatalive = useRef(true);
  const [showbasic, setShowbasic] = useState(true);
  const [showintermediate, setShowintermediate] = useState(true);
  const [showprofessional, setShowprofessional] = useState(true);
  const [currency, setCurrency] = useState("$");
  const [prices, setPrices] = useState({
    Basic: 0,
    Intermediate: 0,
    Professional: 0,
  });
  const [oldPrices, setOldPrices] = useState({
    Basic: 0,
    Intermediate: 0,
    Professional: 0,
  });
  const movedowntopayment = () => {
    window.location.href = "#paymentaccess";
  };

  const goToAccessRegistration = (id: string) => {
    navigate("/doyenaccessregistration/" + id);
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
  };

  const loadingcontent = useCallback(async () => {
    const userDetails = await getUserCountry();
    let accessPrices: any[] = [];
    let idToken = await GetToken();

    if (idToken) {
      let userId = localStorage.getItem("UserId");
      if (!User && userId) {
        const value = await PopulateContext("Users");
        setUsersContext(value);
        const _user = value?.filter((each: any) => each.id === userId);
        setUserContext(_user[0]);
      }
      var emaildata = User?.email || " ";
      await axios
        .get(`${baseUrl}/accessdoyen`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then((response2) => {
          var data232 = response2.data;

          for (const [key02, value02] of Object.entries(data232)) {
            var value101: any;
            value101 = key02;
            value101 = value02;

            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "installment" &&
              value101["typepaystage"] === "second" &&
              value101["product"] === "basicaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowbasic(false);
            }

            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "installment" &&
              value101["typepaystage"] === "second" &&
              value101["product"] === "intermediateaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowintermediate(false);
            }

            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "installment" &&
              value101["typepaystage"] === "second" &&
              value101["product"] === "professionalaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowprofessional(false);
            }
            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "fullpayment" &&
              value101["typepaystage"] === "complete" &&
              value101["product"] === "basicaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowbasic(false);
            }

            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "fullpayment" &&
              value101["typepaystage"] === "complete" &&
              value101["product"] === "intermediateaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowintermediate(false);
            }
            if (
              value101["trackemail"] === emaildata &&
              value101["typepay"] === "fullpayment" &&
              value101["typepaystage"] === "complete" &&
              value101["product"] === "professionalaccess" &&
              value101["counts"] !== "expired"
            ) {
              setShowprofessional(false);
            }
          }
        });
      // });
    } else {
      onAuthStateChanged(auth, (user: any) => {
        if (user) {
          axios
            .get(`${baseUrl}/accessdoyen`, {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            })
            .then((response2) => {
              var data232 = response2.data;

              for (const [key02, value02] of Object.entries(data232)) {
                var value101: any;
                value101 = key02;
                value101 = value02;
                // alert(response.data.data?.CourseName)
                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "second" &&
                  value101["product"] === "basicaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowbasic(false);
                }

                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "second" &&
                  value101["product"] === "intermediateaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowintermediate(false);
                }

                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "second" &&
                  value101["product"] === "professionalaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowprofessional(false);
                }
                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "fullpayment" &&
                  value101["typepaystage"] === "complete" &&
                  value101["product"] === "basicaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowbasic(false);
                }

                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "fullpayment" &&
                  value101["typepaystage"] === "complete" &&
                  value101["product"] === "intermediateaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowintermediate(false);
                }
                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "fullpayment" &&
                  value101["typepaystage"] === "complete" &&
                  value101["product"] === "professionalaccess" &&
                  value101["counts"] !== "expired"
                ) {
                  setShowprofessional(false);
                }
              }
            });
        } else {
          //setToLogin(true);
        }
      });
    }

    try {
      const res = await axios.get(`${baseUrl}/accessprice`, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      accessPrices = await res.data;
      setReady(true);
    } catch (error) {
      console.log(error);
    }

    switch (userDetails.continentCode) {
      case "EU":
        setCurrency("€");
        setPrices({
          ...prices,
          Basic: accessPrices[0].Price.priceInEuros,
          Intermediate: accessPrices[1].Price.priceInEuros,
          Professional: accessPrices[2].Price.priceInEuros,
        });
        setOldPrices({
          ...oldPrices,
          Basic: accessPrices[0].Price.oldPriceInEuros,
          Intermediate: accessPrices[1].Price.oldPriceInEuros,
          Professional: accessPrices[2].Price.oldPriceInEuros,
        });

        break;
      case "AF":
        if (userDetails.countryCode === "NG") {
          setCurrency("NGN");
          setPrices({
            ...prices,
            Basic: accessPrices[0].Price.priceInNaira / 1000,
            Intermediate: accessPrices[1].Price.priceInNaira / 1000,
            Professional: accessPrices[2].Price.priceInNaira / 1000,
          });
          setOldPrices({
            ...oldPrices,
            Basic: accessPrices[0].Price.oldPriceInNaira / 1000,
            Intermediate: accessPrices[1].Price.oldPriceInNaira / 1000,
            Professional: accessPrices[2].Price.oldPriceInNaira / 1000,
          });
        } else {
          setCurrency("$");
          setPrices({
            ...prices,
            Basic: accessPrices[0].Price.priceForOtherAfricans,
            Intermediate: accessPrices[1].Price.priceForOtherAfricans,
            Professional: accessPrices[2].Price.priceForOtherAfricans,
          });
          setOldPrices({
            ...oldPrices,
            Basic: accessPrices[0].Price.oldPriceForOtherAfricans,
            Intermediate: accessPrices[1].Price.oldPriceForOtherAfricans,
            Professional: accessPrices[2].Price.oldPriceForOtherAfricans,
          });
        }

        break;
      default:
        setCurrency("$");
        setPrices({
          ...prices,
          Basic: accessPrices[0].Price.priceInDollars,
          Intermediate: accessPrices[1].Price.priceInDollars,
          Professional: accessPrices[2].Price.priceInDollars,
        });
        setOldPrices({
          ...oldPrices,
          Basic: accessPrices[0].Price.oldPriceInDollars,
          Intermediate: accessPrices[1].Price.oldPriceInDollars,
          Professional: accessPrices[2].Price.oldPriceInDollars,
        });
        break;
    }
  }, [prices, oldPrices, User, setUsersContext, setUserContext]);

  useEffect(() => {
    const fetch = async () => {
      const idToken = await GetToken();

      if (displayDatalive.current === true && idToken) {
        displayDatalive.current = false;
        loadingcontent();
      }
    };

    fetch();
  }, [loadingcontent]);

  useEffect(() => {
    loadings();
  }, []);

  return (
    <div className="">
      {ready ? (
        <>
          <Header />
          <div className="mx-[80px] sm:mx-[40px]">

          <Hero movedowntopayment={movedowntopayment} />

          <div className=" steps">
            <div className="w-[420px] sm:w-full">
              <h4 className="text-[24px] font-bold">
                The first step towards achieving your career dreams!
              </h4>
              <p className="text-[#636363]">
                Invest in your future and get the competitive edge you need to
                succeed in the fast-paced world of tech with our professional IT
                coaching consultations.
              </p>
              <div className="flex gap-3">
                <div className="border-r border-[#D4D4D4]">
                  <p className="text-[14px] text-[#636363]">Total Sessions</p>
                  <h4 className="text-[24px] font-bold">5,000</h4>
                </div>
                <div>
                  <p className="text-[14px] text-[#636363]">Total Hours</p>
                  <h4 className="text-[24px] font-bold">20,000</h4>
                </div>
              </div>
            </div>
          </div>

          <Services />
          <Offerings
            showbasic={showbasic}
            showintermediate={showintermediate}
            showprofessional={showprofessional}
            goToAccessRegistration={goToAccessRegistration}
            prices={prices}
            oldPrices={oldPrices}
            currency={currency}
          />
          <Mentors mentors={mentors} />

          <br />
          <br />
          <br />
          <Footer />
          </div>
        </>
      ) : (
        <>
        <div className="mx-[80px] sm:mx-[40px]">
          <>
            <div>
              <div className="academystyle">
                <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
                <ClipLoader size={25} color="#047E35" />
              </div>
            </div>
          </>
          </div>
        </>
      )}
    </div>
  );
};

export default DoyenAccess;